export type ThemeMode = 'light' | 'dark';

export const THEME_STORAGE_KEY = 'theme';

export function normalizeThemeMode(value: unknown): ThemeMode {
  return value === 'dark' ? 'dark' : 'light';
}

function clearInlineThemeStyles(): void {
  document.body?.style.removeProperty('background-color');
  document.body?.style.removeProperty('color');
  document.documentElement.style.removeProperty('background-color');
  document.documentElement.style.removeProperty('color');
}

export function applyThemeMode(mode: ThemeMode): void {
  const isDark = mode === 'dark';

  document.documentElement.classList.toggle('dark-theme', isDark);
  document.body?.classList.toggle('dark-theme', isDark);

  document.documentElement.style.colorScheme = mode;
  clearInlineThemeStyles();
}

export function getSavedThemeMode(): ThemeMode {
  return normalizeThemeMode(localStorage.getItem(THEME_STORAGE_KEY));
}

export function saveThemeMode(mode: ThemeMode): void {
  localStorage.setItem(THEME_STORAGE_KEY, mode);
}

